import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defaultSchoolTimeZone } from './school-timezones';
import { ConfigService } from './config.service';
import { SecureSessionService } from './secure-session.service';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AcademicService {
  schoolId: any;
  sessionData: any;
  // temp
  academicYearId: any;
  private _academiclistUrl = "AcademicYear/get-all-AcademicYear";
  private _createAcademicYearUrl = "AcademicYear/create-AcademicYear";
  private _editAcademivYearUrl = "AcademicYear/update-AcademicYear";
  private _academicYearById = "AcademicYear/get-AcademicYear-by-id";
  private _getSchoolDetailsUrl = "School/get-school-details";
  private _createSchoolUrl = "School/register-school";
  private _updateSchoolUrl = "School/update-school";
  private _setActiveAcademicYearUrl = "AcademicYear/activate-academicyear";
  private _getStudentsByAcademicYear = "AcademicYear/get-StudentList-by-AcademicYear";
  private _getAllSubjectBySchoolId = "Subject/get-all-sub";
  private _getStudentDetailsByAcademicYear = "AcademicYear/get-Student-details-by-AcademicYear";
  private _getStudentDetails = "/AcademicYear/student-details";
  private _getTopPerformer = "GradebookTeacher/top-performers";
  private _schoolMemberDistribution = "AdminLogin/get-user-distribution-percentage";
  private _getExpenseChartData = "Fee/monthly-status/raw";

  private _setDeactiveAcademicYearUrl = "AcademicYear/deactivate-academicyear";
  private _getDasboardTopPerformer = "GradebookTeacher/top-performers-by-class-latest-published/";


  constructor(private http: HttpClient, private _config: ConfigService, private session: SecureSessionService) {
    this.sessionData = JSON.parse(this.session.getSession());
    this.schoolId = this.sessionData[0].schoolId;
    // temp
    this.academicYearId = this.sessionData[0].academicYearId;
  }
  //getClass()



  getAcademicYearList(): Observable<any> {

    console.log(this.schoolId);
    console.log("this.sessionData");
    return this.http.get<any>(this._config._url + this._academiclistUrl + '/' + this.schoolId).pipe(
      catchError(this.handleError)
    );
  }

  getAcademicYearListBySchoolId(schoolId: any): Observable<any>{
    return this.http.get<any>(this._config._url + this._academiclistUrl + '/' + schoolId).pipe(
      catchError(this.handleError)
    );
  }
  getAcademicYearById(id: any): Observable<any> {
    return this.http.get<any>(this._config._url + this._academicYearById + '/' + id).pipe(
      catchError(this.handleError)
    );
  }
  getStudentDetails(studentId:any):Observable<any>{
    return this.http.get<any>(this._config._url+this._getStudentDetails+'?studentId='+studentId+'&academicYearId='+this.academicYearId).pipe(catchError(this.handleError));
  }
  createAcademic(academicData: any) {
    return this.http.post<any>(this._config._url + this._createAcademicYearUrl, academicData).pipe(
      catchError(this.handleError)
    );
  }
  updateAcademicYear(academicYearId: any, academicData: any) {
    return this.http.put<any>(this._config._url + this._editAcademivYearUrl + '/' + academicYearId, academicData).pipe(
      catchError(this.handleError)
    );
  }
  getTopPerformer(){
    return this.http.get<any>(`${this._config._url}${this._getTopPerformer}?schoolId=${this.schoolId}`).pipe(catchError(this.handleError));
  }
  getTopPerformersByClass(){
    return this.http.get<any>(`${this._config._url}${this._getDasboardTopPerformer}${this.schoolId}`).pipe(catchError(this.handleError));
  }
  getSchoolMemberDistribution(){
    return this.http.get<any>(this._config._url+this._schoolMemberDistribution+"/"+this.schoolId+"/"+this.academicYearId).pipe(catchError(this.handleError));
  }
  setAcademicYear(academicYearId: any) {
    return this.http.put<any>(this._config._url + this._setActiveAcademicYearUrl + '/' + academicYearId + '/' + this.schoolId + '?forceActivate=true', {}).pipe(
      catchError(this.handleError)
    );
  }
    deactivateAcademicYear(academicYearId: any) {
    return this.http.put<any>(this._config._url + this._setDeactiveAcademicYearUrl + '/' + academicYearId + '/' + this.schoolId, {}).pipe(
      catchError(this.handleError)
    );
  }
  getSchoolDetails(): Observable<any> {

    return this.http.get<any>(this._config._url + this._getSchoolDetailsUrl + '/' + this.schoolId).pipe(
      catchError(this.handleError)
    );
  }
  updateSchool(schoolData: any) {
    return this.http.put<any>(this._config._url + this._updateSchoolUrl + '/' + this.schoolId, schoolData).pipe(
      catchError(this.handleError)
    );
  }
  registerSchool(data: FormData): Observable<any> {
    if (!data.has('TimeZoneId')) {
      data.set('TimeZoneId', String(data.get('timeZoneId') || defaultSchoolTimeZone()));
    }
    return this.http.post<any>(this._config._url + this._createSchoolUrl,  data);
  }

  getAllSubjectBySchoolId(): Observable<any> {
    return this.http.get<any>(this._config._url+this._getAllSubjectBySchoolId+'/'+this.schoolId).pipe(catchError(this.handleError));
  }

  getStudentsByAcademicYear(schoolData: any):Observable<any> {
    return this.http.post<any>(this._config._url+this._getStudentsByAcademicYear, schoolData).pipe(catchError(this.handleError));
  }

  getExpenseChartData(fromDate:any,toDate:any) {
    const currentYear = new Date().getFullYear();
    const params = new HttpParams()
      .set('schoolId', this.schoolId)
      .set('fromDate', fromDate)  // January 1st of current year
      .set('toDate', toDate); 
      // .set('fromDate', `${currentYear}-01-01`)  // January 1st of current year
      // .set('toDate', `${currentYear}-12-31`); 
    return this.http.get<any>(this._config._url + this._getExpenseChartData, { params }).pipe(catchError(this.handleError));
  }


  handleError(error: HttpErrorResponse): Observable<never> {

    let errorMessage = '';
    let validationMessages: string[] = [];

    // Log the full error to inspect its structure
    console.error('Full error response:', error);

    // Check for client-side error
    if (error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
    } else {
        // Handle 409 Conflict error globally (regardless of the specific error message)
        if (error.status === 409 && error.error) {
            // If the error has a general message or specific errormessage, use it
            errorMessage = ` ${error.error.message || error.error.errormessage || 'Unknown conflict error'}`;
        }
        // Handle 400 errors (validation errors)
        else if (error.status === 400 && error.error) {
            if (error.error.errors) {
                // If it's an object, it could contain detailed validation messages
                for (const field in error.error.errors) {
                    if (error.error.errors.hasOwnProperty(field)) {
                        // Add each field's validation message to the list
                        validationMessages.push(`${field}: ${error.error.errors[field].join(', ')}`);
                    }
                }
            } else {
                // Handle if no specific validation errors but just a general message
                validationMessages.push(error.error.message || 'Unknown validation error');
            }

            // Combine validation messages
            errorMessage = validationMessages.join(' | ') || 'Unknown validation error';
        }
        // Handle 404 Not Found error
        else if (error.status === 404 && error.error) {
            // If the error contains a message object like { "message": "Error in name field" }
            errorMessage = `Not Found: ${error.error.message || 'Resource not found'}`;
        } else {
            // Handle other server-side errors
            errorMessage = `Server-side error: ${error.status} - ${error.message}`;
        }
    }

    // Log the final error message
    console.error('Processed error message:', errorMessage);

    // Return the error message as an observable
    return throwError(() => new Error(errorMessage));
}

}


